import { render, staticRenderFns } from "./SelectorLocalidadeObj.vue?vue&type=template&id=e12c10f8&scoped=true"
import script from "./SelectorLocalidadeObj.vue?vue&type=script&lang=js"
export * from "./SelectorLocalidadeObj.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/vendor/libs/vue-multiselect/vue-multiselect.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "./SelectorLocalidadeObj.vue?vue&type=style&index=2&id=e12c10f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12c10f8",
  null
  
)

export default component.exports